import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const PaymentPage = () => {
  const [searchParams] = useSearchParams();
  const paymentUrl = searchParams.get('url');
  const orderId = searchParams.get('orderId');
  const [loading, setLoading] = useState(true);

  return (
    <div className="payment-page">
      <div className="payment-header">
        <h1>Complete Your Payment</h1>
        <p className="order-id">Order ID: <span>{orderId}</span></p>
      </div>
      
      {loading && (
        <div className="payment-loading">
          <div className="spinner"></div>
          <p>Connecting to payment gateway...</p>
        </div>
      )}
      
      <iframe
        src={paymentUrl}
        title="Payment Gateway"
        className="payment-iframe"
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default PaymentPage;
